<template>
  <div class="ai-source-tag">
    <div class="tag-icon-wrapper">
      <font-awesome-icon :icon="['fas', 'lightbulb']" style="color: #cbbdd0; font-size: 11px; opacity: 0.8;" />
    </div>
    <span class="tag-text">
      <slot>{{ $t('generated_by_ai') }}</slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AISourceTag',
};
</script>

<style scoped>
.ai-source-tag {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #fbf7ff 0%, #fdfaf9 100%);
  border-radius: 12px;
  padding: 4px 8px;
  font-size: 10px;
  color: #999;
}

.tag-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 4px;
}

.tag-text {
    line-height: normal;
}
</style>
